module.exports = __webpack_public_path__ + "img/Artboard.11d36aea.png";